import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// The Watching list's Crammed view: the grid packed tight for a screenshot,
// everything else hidden. A class on <html> (rw-shot, styled in watch.css)
// while the view is open; Esc goes back to the Grid.
export default class extends Controller {
  static values = { on: Boolean, exitUrl: String }

  connect() {
    if (!this.onValue) return
    document.documentElement.classList.add("rw-shot")
    this.onKey = (event) => { if (event.key === "Escape") Turbo.visit(this.exitUrlValue) }
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.documentElement.classList.remove("rw-shot")
    if (this.onKey) document.removeEventListener("keydown", this.onKey)
  }
}
